module.exports = __webpack_public_path__ + "static/media/sheets.7e839f70.svg";